module.exports = "/_next/static/images/62b6ed5bca7aa21842ddf3a01d5ea8c4-roxinho-details-metalico-xs@3x.jpg.webp";